import { apiHttp } from 'shared/request'
import { ListResponse, SuccessResponse } from 'shared/request'

import { SingleNFT, MultipleNFT } from 'core/upload/models'

import { pathJoin } from 'shared/utils'

const URI = 'upload'

export const upload = (params: SingleNFT) => {
    const url = pathJoin('admin', 'nft', URI)
    return apiHttp.put<SuccessResponse<ListResponse<void>>>(url, params)
}

export const uploadZip = (params: MultipleNFT) => {
    const url = pathJoin('admin', 'nft', URI, 'zip')
    return apiHttp.put<SuccessResponse<ListResponse<void>>>(url, params)
}
